import NotificationPopupModal from './NotificationPopupModal'
import NotificationsView from './NotificationsView'
import useNotifications, { NotificationsInputProps } from './useNotifications'

import React from 'react'

import { withHook } from 'utilities'

const Notifications: React.FC<NotificationsInputProps> = withHook({
  hook: useNotifications,
  component: NotificationsView,
})
export default Notifications
export { NotificationPopupModal }
